
import moment from 'moment'
//import {Trans} from '@/plugins/Translation'

export const countdownBehavior = {
    mixins:[],
    props:{
        customStartDate:{
            type:String
        },
        customEndDate:{
            type:String
        },
        preReleaseMinutes:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            countdownTimer:null,
            loopMilliSeconds:500,
            loopSecondsCounter:0,
            progress:null,
            progressClass:null,
            years:"",
            months:"",
            days:"",
            hours:"",
            minutes:"",
            seconds:"",
            preOutput:"",
            finalDate:null,
            onInitTime:new Date().getTime(),
            closeCountDownAfterEnd:false,
            lblPrefixStartIn:"Stream startet in",//Trans.t('label_start_in'),
            lblPrefixEndIn:"Stream endet in",//Trans.t('label_end_in'),
            lblPrefixEndBefore:"Stream beendet seit",//Trans.t('label_end_before'),
            lblPrefixFinished:"Beendet",//Trans.t('label_ended'),
            lastState:null,
            selectedHour:null,
        }
    },
    computed: {

        startDate(){
            let startDate= this.customStartDate;
            return (startDate)?new Date(Date.parse(startDate)):null;
        },
        endDate(){
            let endDate= this.customEndDate;
            return (endDate)?new Date(Date.parse(endDate)):null;
        },
        getCountdownDate(){
            let d=(this.finalDate)?this.finalDate:new Date().getTime();
            return moment(d).format();
        },
        getTitle(){
            return (this.preOutput)?this.preOutput:'';
        }

    },
    beforeDestroy(){
        this.stopCountdown();
    },
    methods:{
        startCountdown(){
            this.countdownTimer=setInterval(this.countdownLoop,this.loopMilliSeconds);
        },
        stopCountdown(){
            if(this.countdownTimer){
                clearInterval(this.countdownTimer);
                this.countdownTimer=null;
            }
        },
        calculateOutput(distance){

            var distancedate = moment(distance); // miliseconds from epoch
            var momentDate=moment.duration(distance);
            if(momentDate && distancedate){
                this.years = momentDate.years();//Math.abs(distancedate.getUTCFullYear() - 1970);
                this.months = momentDate.months();
                this.days = momentDate.days();//Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / ((1000 * 60 * 60 * 24)));
                this.hours = momentDate.hours();//Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.minutes = momentDate.minutes();//Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = momentDate.seconds();//Math.floor((distance % (1000 * 60)) / 1000);
            }
        },
        scale (num, in_min, in_max, out_min, out_max){
            return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
        },
        calculateProgress(lblPreFix,val,min,max,calculateProgress){
            var distance=max-val;
            this.finalDate=max;
            this.preOutput=lblPreFix;
            this.calculateOutput(distance);
            this.progress=(calculateProgress)?100-this.scale(val,min,max,0,100):100;
        },
        countdownLoop(){
            
            if(this.startDate && this.endDate){
                let now = new Date().getTime();
                let preReleaseMin=(this.preReleaseMinutes)?(this.preReleaseMinutes*60000):0;
                let startDateTime=this.startDate.getTime();
                let endDateTime=this.endDate.getTime();
                let eventBeforeStart=((startDateTime - now -preReleaseMin)>0);
                let eventAfterEnd= ((endDateTime-now)<0);
                let currentState=null;

                if(eventBeforeStart){
                    currentState="before_start";
                    this.calculateProgress(this.lblPrefixStartIn,now,this.onInitTime,startDateTime,true);
                }else if(eventAfterEnd){
                    currentState="after_end";
                    let title=(this.closeCountDownAfterEnd)?this.lblPrefixFinished:this.lblPrefixEndBefore;
                    this.calculateProgress(title,endDateTime,now,now,false);
                }else{
                    currentState="in_time";
                    this.calculateProgress(this.lblPrefixEndIn,now,startDateTime,endDateTime,true);
                }
                
                if(this.lastState!=currentState){
                    this.emitUpdateState(currentState);
                }

                this.lastState=currentState;
                this.loopSecondsCounter++;

                if((this.loopSecondsCounter%2)==0){
                    this.$emit('tick',now);
                }
                if(this.loopSecondsCounter>=60){
                    this.$emit('tickMinute',now);
                    this.loopSecondsCounter=0;
                }
                this.emitTickHourInclufingChecks();
            }
        },
        emitTickHourInclufingChecks(){
            let currentHours=new Date().getHours();
            let hourChanged=(null!=this.selectedHour && this.selectedHour!=currentHours);
      
            if(hourChanged){
                this.$emit('tickHour');
            }
            this.selectedHour =currentHours;
        },
        emitUpdateState(currentState){
            this.$emit('updatedState',currentState);
        }
    },

}